import { MenuItem } from "@mui/material";
import ProfileButton from "e.sic-platform.webclient/src/components/navbar/ProfileButton";
import { authentication } from "e.sic-platform.webclient/src/services/authentication/Authentication";
import { creditBalanceStorage } from "e.sic-platform.webclient/src/services/shop/CreditBalanceStorage";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import LoginButton from "../buttons/authentication/LoginButton";

export default observer(function ProfileMenu() {
    if (authentication.anonymous) return (<AnonymousMenu />)
    else return (<AuthenticatedMenu />)
})

export const AuthenticatedMenu = observer(function AuthenticatedMenu() {
    const navigate = useNavigate();

    const logoutFunction = useCallback(() => {
        authentication.logout();
    }, [authentication]);
    
    const goToMyAccount = useCallback(() => {
        navigate("/my-account");
    }, []);
    
    const goToHistory = useCallback(() => {
        navigate("/app-usage");
    }, []);
    
    const goToOrders = useCallback(async () => {
        var link = await creditBalanceStorage.getCustomerPortalSessionLink();
        window.location.href = link;
    }, [creditBalanceStorage]);
    
    return (
        <>
            <ProfileButton logoutFunction={logoutFunction}>
              <MenuItem onClick={goToMyAccount}>
                {translationService.translate("general.my-account")}
              </MenuItem>
              <MenuItem onClick={goToHistory}>
                {translationService.translate("general.shop.history")}
              </MenuItem>
              <MenuItem onClick={goToOrders}>
                {translationService.translate("general.shop.orders")}
              </MenuItem>
            </ProfileButton>
        </>
    )
})

export const AnonymousMenu = observer(function AnonymousMenu() {
    return (<LoginButton />)
})